import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">关于我们</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">了解黑料吃瓜网背后的故事与理念</p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-5xl mx-auto">
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="w-full aspect-[8/5] rounded-lg overflow-hidden">
              <img
                src={aboutData.image}
                alt="黑料吃瓜网团队"
                title="黑料吃瓜网 - 关于我们"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <h3 className="text-xl md:text-2xl font-heading text-foreground-900">{aboutData.title}</h3>
            {aboutData.content.split('\n\n').map((paragraph, idx) => (
              <p key={idx} className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}